import BaseAPI from "./BaseAPI";
import { productionContextRoute } from "../routes";

/**
 * Server-assembled view for the production form: returns recipes + their
 * referenced stocks + each stock's available intakes (across meats/ingredients/
 * packaging) + supplier metadata, all in one shape. Replaces the four separate
 * calls the production form used to make.
 */
export default class ProductionContextAPI extends BaseAPI {
    constructor(emitterInstance) {
        super(emitterInstance, productionContextRoute, "production-context");
    }

    /**
     * Fetch production context for one or more recipes.
     * @param {string|string[]} recipeIDs Single id or array of recipe ObjectIDs (hex)
     * @param {string} [locationID] Optional location filter for meat/ingredient intakes
     * @returns {Promise<{recipes: Array, stocks: Object}>}
     */
    async Get(recipeIDs, locationID = null) {
        const ids = Array.isArray(recipeIDs) ? recipeIDs : [recipeIDs];
        let qs = `?recipe_ids=${ids.join(",")}`;
        if (locationID) qs += `&location_id=${encodeURIComponent(locationID)}`;
        return this._request("get", this._url(qs));
    }
}
